export default "__VITE_ASSET__fcbe696f__"